export function disableStripeFeatures(user: User | null | undefined) {
  return (
    user?.sub === "9cba7758-55fb-4ec4-84df-213db5fc687b" || // test account
    user?.sub === "0743dcd7-4775-45ed-bc0b-67487a2f4216" // david C. account
  );
}
